/* eslint-disable no-irregular-whitespace */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const ESG_GERL_QUIZ_COMMENT_TEMPLATE = `1. AZ Trade OE involved in the deal
please specify

2. Description of the business/transaction covered
i.e. specify here if the transaction is a single-site; multi-site coverage and provide background on the business transaction.   
 
3. Tenor of the policy 
- Start date: 
- End date: 
- Tenor: 
- Tacit renewal: 
  ☐​ Yes
  ☐​ No

4. Amount insured/covered & expected premium 
- Amount insured/covered: 
- Expected premium: 

5. Co-insurance/syndication 
☐ Yes: (please specify) 
  - Signed share: 
  - Role of AZ Trade (participant or leader): 
  - Level of confidentiality: 
☐ No 

6. Deviations from AZ Trade Commercial Rules 
☐ Yes: (please specify) 
☐ No

7. Type of client relationship (needed once tool is also used for renewals)
☐ Renewal
☐ New business

8. Previous/existing business relationship with client/business partner
please specify

9. Is this case referred to the GSO for the first time?  
☐ Yes
☐ No: (please specify date of previous referral) 

10. Your contact details
- Name: 
- Email: 
`;

export const esgGerlQuizCommentChangedValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const hasChanged = control.value !== ESG_GERL_QUIZ_COMMENT_TEMPLATE;
  return hasChanged ? null : { unchanged: true };
};
